import PropTypes from 'prop-types';
import EntityStore from '../../helpers/EntityStore';
import ValueStore from '../../helpers/ValueStore';
import BoolStore from '../../helpers/BoolStore';

export const REGISTRATION_TYPE = {
    SAML_SSO: 'SAML_SSO',
    ACTIVATION_CODES: 'ACTIVATION_CODES',
    ACTIVATION_LINKS: 'ACTIVATION_LINKS',
};

export default class BrowserIsolationOptionsStore extends EntityStore {
    static _PropType = {
        browserRegistrationEnabled: BoolStore.PropTypes,
        anonymousUsage: BoolStore.PropTypes,
        browserAuthenticationMethod: ValueStore.PropTypes,
        allowResearchMode: BoolStore.PropTypes,
        ...EntityStore._PropType,
    };

    static PropType = PropTypes.shape(BrowserIsolationOptionsStore._PropType);

    constructor(data = {}) {
        super({
            browserRegistrationEnabled: new BoolStore(true),
            anonymousUsage: new BoolStore(false),
            browserAuthenticationMethod: new ValueStore(REGISTRATION_TYPE.ACTIVATION_CODES),
            allowResearchMode: new BoolStore(false),
        }, data);
    }
}
